import { useState, useEffect } from "react";

export const monthName = (num) =>
  [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][num - 1] || "—";

export const isExtinguisher = (name) =>
  name && name.toLowerCase().includes("extinguisher");

// Converts a stored UTC ISO string into what the browser's own local wall
// clock reads, for seeding a <input type="datetime-local"> — uses Date's
// local-time getters (not the UTC variants) so this is a real timezone
// conversion, not a naive string slice.
export function isoToLocalInputValue(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Reverse of isoToLocalInputValue — a bare datetime-local string (no
// timezone offset) is parsed by `new Date(...)` as local time automatically,
// so toISOString() correctly converts it back to true UTC for the backend.
export function localInputValueToIso(value) {
  return value ? new Date(value).toISOString() : null;
}

// Natural sort comparator for unit numbers ("2" before "10", not after) —
// matches the backend's natural_sort_key in SiteUnitViewSet so combined
// tenant/unit reports order the same way the Units list does.
export function naturalCompare(a, b) {
  const ax = String(a ?? "").match(/\d+|\D+/g) || [];
  const bx = String(b ?? "").match(/\d+|\D+/g) || [];
  const len = Math.max(ax.length, bx.length);
  for (let i = 0; i < len; i++) {
    const av = ax[i] ?? "";
    const bv = bx[i] ?? "";
    if (av === bv) continue;
    const an = /^\d+$/.test(av), bn = /^\d+$/.test(bv);
    if (an && bn) {
      const diff = parseInt(av, 10) - parseInt(bv, 10);
      if (diff !== 0) return diff;
    } else {
      const cmp = av.toLowerCase().localeCompare(bv.toLowerCase());
      if (cmp !== 0) return cmp;
    }
  }
  return 0;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}
